import styled from 'styled-components/macro';

export const ClassroomContainer = styled.div`
  grid-area: content;
  height: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
